// @ts-nocheck
import React, { useState, useEffect, useContext } from "react";
import http from "../../../api/apiClient";
import { AuthContext } from "../../../AuthProvider";
import Modal from "../../../components/Modal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaChild } from "react-icons/fa";
import {
    LdsOverviewHero,
    LdsOverviewPage,
} from "../../../components/lds/LdsOverview";

import { useLeaveForm } from "../../../components/navigation/BackButton";
const childNewStyles = `
  @keyframes childNewEnter {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .child-new-enter {
    animation: childNewEnter 420ms cubic-bezier(0.22, 1, 0.36, 1);
    animation-fill-mode: both;
  }

  @media (prefers-reduced-motion: reduce) {
    .child-new-enter {
      animation: none !important;
    }
  }
`;

const ChildNew = () => {
    const { keycloak } = useContext(AuthContext);
    const navigate = useNavigate();
  const leaveForm = useLeaveForm();
    const { t } = useTranslation();

    // Helper function to get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        return new Date().toISOString().split("T")[0];
    };



    // Form State
    const [firstName, setFirstName] = useState("");
    const [bsn, setBsn] = useState("");
    const [lastName, setLastName] = useState("");
    const [gender, setGender] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [dateOfRegistration, setDateOfRegistration] = useState(getTodayDate()); // Auto-fill with today
    const [families, setFamilies] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedFamily, setSelectedFamily] = useState("");
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState({ show: false, type: "", title: "", message: "", navigateOnClose: false });
    const filteredFamilies = families.filter((family) =>
        family.familyName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const labelClass = "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400";
    const inputClass =
        "w-full rounded-2xl border border-gray-200/70 bg-white/80 px-4 py-2 text-gray-900 shadow-sm focus:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-gray-700 dark:bg-gray-900/60 dark:text-gray-100";

    useEffect(() => {
        // Fetch families for selection
        const fetchFamilies = async () => {
            try {
                const response = await http.get("/families");
                setFamilies(response.data);
            } catch (error) {
                console.error("Failed to load families:", error);
            }
        };

        if (keycloak?.token) {
            fetchFamilies();
        }
    }, [keycloak]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!firstName.trim() || !lastName.trim() || !bsn || !gender || !dateOfBirth || !selectedFamily || !dateOfRegistration) {
            setModal({
                show: true,
                type: "error",
                title: t("common.modal.error"),
                message: t("children.new.validation_error"),
            });
            return;
        }

        const childData = {
            firstName,
            lastName,
            bsn,
            gender,
            dateBirth: dateOfBirth,
            dateRegistration: dateOfRegistration, // Send registration date
            familyId: selectedFamily,
        };

        try {
            setLoading(true);
            await http.post("/children", childData);

            setModal({
                show: true,
                type: "success",
                title: t("common.modal.success"),
                message: t("children.new.success"),
                navigateOnClose: "/family/children",
            });
        } catch (error) {
            console.error("Error creating child:", error.response?.data || error.message);
            setModal({
                show: true,
                type: "error",
                title: t("common.modal.error"),
                message: t("children.new.error"),
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <LdsOverviewPage styles={<style>{childNewStyles}</style>}>
            <LdsOverviewHero
                icon={FaChild}
                eyebrow={t("children.name", { defaultValue: "Children" })}
                title={t("children.new.title")}
                description={t("children.new.subtitle", { defaultValue: "Voeg een kind toe" })}
            />
            <div className="flex flex-col gap-6 text-gray-900 dark:text-gray-100">
                <form
                    onSubmit={handleSubmit}
                    className="child-new-enter rounded-[28px] border border-slate-200/80 bg-white/95 p-6 shadow-[0_14px_35px_rgba(15,23,42,0.07)] dark:border-slate-800 dark:bg-slate-950"
                >
                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                            <p className="text-sm uppercase tracking-wide text-gray-500 dark:text-gray-400">
                                {t("children.new.subtitle", "Voeg een kind toe")}
                            </p>
                            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                                {t("children.new.title")}
                            </h2>
                        </div>
                        {dateOfRegistration && (
                            <span className="rounded-full border border-indigo-200/70 bg-white/70 px-4 py-1.5 text-xs font-semibold text-indigo-700 dark:border-indigo-500/50 dark:bg-indigo-950/40 dark:text-indigo-200">
                                {t("children.common.date_of_registration")}: {dateOfRegistration}
                            </span>
                        )}
                    </div>

                    <div className="mt-6 grid gap-5 sm:grid-cols-2">
                        <div className="space-y-2">
                            <label className={labelClass}>{t("children.common.first_name")}</label>
                            <input
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                className={inputClass}
                                required
                            />
                        </div>
                        <div className="space-y-2">
                            <label className={labelClass}>{t("children.common.last_name")}</label>
                            <input
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                className={inputClass}
                                required
                            />
                        </div>
                        <div className="space-y-2">
                            <label className={labelClass}>{t("children.common.bsn")}</label>
                            <input
                                type="text"
                                value={bsn}
                                onChange={(e) => setBsn(e.target.value)}
                                className={inputClass}
                                required
                            />
                        </div>
                        <div className="space-y-2">
                            <label className={labelClass}>{t("children.common.gender")}</label>
                            <select
                                className={inputClass}
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                required
                            >
                                <option value="">{t("children.common.select_gender")}</option>
                                <option value="M">{t("children.common.gender_male")}</option>
                                <option value="F">{t("children.common.gender_female")}</option>
                            </select>
                        </div>
                    </div>

                    <div className="mt-5 grid gap-5 sm:grid-cols-2">
                        <div className="space-y-2">
                            <label className={labelClass}>{t("children.common.date_of_birth")}</label>
                            <input
                                type="date"
                                value={dateOfBirth}
                                onChange={(e) => setDateOfBirth(e.target.value)}
                                className={inputClass}
                                required
                            />
                        </div>
                        <div className="space-y-2">
                            <label className={labelClass}>{t("children.common.date_of_registration")}</label>
                            <input
                                type="date"
                                value={dateOfRegistration}
                                onChange={(e) => setDateOfRegistration(e.target.value)}
                                className={inputClass}
                                required
                            />
                        </div>
                    </div>

                    <div className="mt-5 space-y-2">
                        <label className={labelClass}>{t("children.common.family")}</label>
                        <div className="relative">
                            <input
                                type="text"
                                className={inputClass}
                                value={
                                    selectedFamily
                                        ? families.find((f) => f.id === selectedFamily)?.familyName
                                        : searchQuery
                                }
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder={t("family.overview.search_placeholder")}
                                required
                            />
                            {searchQuery && filteredFamilies.length > 0 && (
                                <ul className="absolute z-10 mt-2 max-h-40 w-full overflow-y-auto rounded-2xl border border-indigo-100 bg-white/95 shadow-xl dark:border-gray-700 dark:bg-gray-900">
                                    {filteredFamilies.map((family) => (
                                        <li
                                            key={family.id}
                                            className="cursor-pointer px-4 py-2 text-sm text-gray-700 transition hover:bg-indigo-50 dark:text-gray-200 dark:hover:bg-gray-800"
                                            onClick={() => {
                                                setSelectedFamily(family.id);
                                                setSearchQuery("");
                                            }}
                                        >
                                            {family.familyName}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    <div className="mt-8 flex flex-wrap items-center justify-end gap-3">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="lumen-glow-sheen inline-flex items-center rounded-full border border-gray-200/70 bg-white/80 px-5 py-2 text-sm font-semibold text-gray-700 transition hover:text-gray-900 dark:border-gray-600/40 dark:bg-gray-900/40 dark:text-gray-200"
                        >
                            {t("common.cancel")}
                        </button>
                        <button
                            type="submit"
                            className="lumen-glow-sheen inline-flex items-center rounded-full border border-indigo-200/70 bg-indigo-50/80 px-6 py-2 text-sm font-semibold text-indigo-700 transition hover:text-indigo-900 dark:border-indigo-500/50 dark:bg-indigo-950/40 dark:text-indigo-200 disabled:cursor-not-allowed disabled:opacity-60"
                            disabled={loading}
                        >
                            {loading ? t("common.loading") : t("children.new.create")}
                        </button>
                    </div>
                </form>
            </div>

            {/* Success/Error Modal */}
            <Modal
                show={modal.show}
                type={modal.type}
                title={modal.title}
                message={modal.message}
                onClose={() => {
                    setModal({ show: false });
                    if (modal.navigateOnClose) leaveForm(modal.navigateOnClose);
                }}
            />
        </LdsOverviewPage>
    );
};

export default ChildNew;
